// removed by extract-text-webpack-plugin
module.exports = {"bg-gray":"Home-module-bg-gray-2NkoB","bgGray":"Home-module-bg-gray-2NkoB","mobile-container":"Home-module-mobile-container-CIGfD","mobileContainer":"Home-module-mobile-container-CIGfD","latest-bulletins":"Home-module-latest-bulletins-1xy9h","latestBulletins":"Home-module-latest-bulletins-1xy9h","title":"Home-module-title-1V26r","overflow-hidden":"Home-module-overflow-hidden-3HewO","overflowHidden":"Home-module-overflow-hidden-3HewO","description":"Home-module-description-2h45B"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/Home.module.scss
// module id = 1115
// module chunks = 0